module.exports = __webpack_public_path__ + "img/allstudents.0e147f61.svg";